/* eslint-disable */
export default {
  feedbackHeader: 'Enviar feedback',
  back: 'Voltar',
  revert: 'Reverter',
  instruction:
    'Os seus comentários são importantes para nós. Caso tenha problemas ao utilizar a aplicação, pretenda solicitar uma funcionalidade ou comunicar um erro, teremos todo o prazer em ajudar.',
  fillForm: 'Preencha o formulário abaixo e clique em ',
  useMailBox:
    ' ou utilize diretamente a caixa de correio e envie o pedido para ',
  email: 'O seu endereço de e-mail',
  reply: '(para que possamos responder)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'Tópico de feedback',
  topicPlaceHolder: 'Selecione uma opção',
  bugReport: 'Relatório de erros',
  featureRequest: 'Solicitar funcionalidade',
  others: 'Outros',
  subject: 'Assunto',
  subjectPlaceHolder: 'Diga-nos como podemos ajudá-lo',
  description: 'Descrição completa',
  descriptionPlaceHolder: 'Inclua o máximo de informações possível',
  send: 'Envie o seu feedback',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
